import { Component, OnInit } from '@angular/core';

import { VtmnPlayButtonVariantStyleEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant-style.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { TitleService } from '~/core/services/title/title.service';

@Component({
  selector: 'app-organizer-activity-sharing-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class OrganizerActivitySharingPageSuccessComponent implements OnInit {
  public readonly desktopBackgroundImage =
    'assets/success/checkout-success-layout-desktop.jpg';
  public readonly mobileBackgroundImage =
    'assets/success/checkout-success-layout-mobile.jpg';
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonStyle = VtmnPlayButtonVariantStyleEnum;

  constructor(private readonly titleService: TitleService) {}

  public ngOnInit(): void {
    this.titleService.setPageTitle(
      'seo.organizer.activity_sharing.success.title'
    );
  }
}
